/// <reference path="../types/BuilderFactoryTypes.ts" />

import IAJAXOptions = Wollmilch.IAJAXOptions;

class AuthenticationManager
{
	public Events: Backbone.Events;
	private AuthToken: string;
	private Account: Wollmilch.AccountObject | null;
	private Company: Wollmilch.CompanyObject;
	private Person: number | null;
	private Employee: Wollmilch.EmployeeObject | null;
	private RememberMe: boolean;

	private Contacts: {raw: any[], list: any[], grouped: any[]};

	constructor()
	{
		this.AuthToken  = '';
		this.Account    = null;
		this.Company    = this.getEmptyCompany();
		this.Person     = null;
		// Todo Employee Object
		this.Employee   = null;
		this.RememberMe = false;
		this.Events = Backbone.Events;

		this.Contacts = {raw: [], list: [], grouped: []};
	}

	public getAccount() : Wollmilch.AccountObject | null
	{
		return this.Account;
	}

	public getPerson() : number | null
	{
		return this.Person;
	}

	public getCompany() : Wollmilch.CompanyObject
	{
		return this.Company;
	}

	public setCompany(company: Wollmilch.CompanyObject)
	{
		this.Company = company;
		this.Events.trigger('change:Company');
	}

	public setEmployee(employee: Wollmilch.EmployeeObject)
	{
		this.Employee = employee;
		this.Events.trigger('change:Employee');
	}

	public getEmptyCompany(): Wollmilch.CompanyObject
	{
		return {
			ID: 0,
			Name: '',
			LastEdited: 'never',
			Shortcut: '',
			LegalForm: '',
			CreatedAt: 'never',
			Account: null,
			Type: 'Company',
			Address: [],
			Inferior: []
		};
	}

	public getEmployee(): Wollmilch.EmployeeObject | null
	{
		return this.Employee;
	}

	public getAuthToken() : string | null {
		return this.AuthToken;
	}

	public createModal() : void
	{
		const form = new Form( { tag: 'div', orientation: 'horizontal' } );

		let formgroup = form.newFormGroup([ 1 ]);

		let label = 'Benutzername/E-Mail';

		const inputUser = new InputText(
			{
				value: '',
				name: 'INPUT_USERNAME_LOGIN_FORM_MODAL',
				placeholder: typeof label === 'string' ? label : '',
				disabled: false,
				id: 'INPUT_USERNAME_LOGIN_FORM_MODAL_id'
			}
		);

		label = app.getMessage('AuthenticationManager.LOGIN_FORM.LABEL_PASSWORD');
		const inputPass = new InputPassword(
			{
				value: '',
				name: 'INPUT_PASSWORD_LOGIN_FORM_MODAL',
				placeholder: typeof label === 'string' ? label : '',
				disabled: false,
				id: 'INPUT_PASSWORD_LOGIN_FORM_MODAL_id'
			}
		);

		formgroup.addItem(
			{
				label: typeof label === 'string' ? new InputLabel( { value: label } ) : undefined,
				input: inputUser
			}
		);

		formgroup = form.newFormGroup([ 1 ]);

		formgroup.addItem(
			{
				label: typeof label === 'string' ? new InputLabel( { value: label } ) : undefined,
				input: inputPass
			}
		);

		const header = $(document.createElement('h3'));
		header.text(app.getMessage('AuthenticationManager.LOGIN_MODAL.HEADER'));

		const loginBtn = new Button(
			{
				id: '',
				title: app.getMessage('AuthenticationManager.LOGIN_MODAL.SUBMIT_BTN'),
				size: 'sm',
				style: 'success',
				behaviour: 'button'
			}
		);

		$( loginBtn.getElement() ).on( 'click', (): void => this.login() );
		$(inputUser.getElement()).on('keypress', (e) => {
			if ((e.target as HTMLInputElement).value.trim() !== '' && e.key === 'Enter') {
				inputPass.getElement().focus();
			}
		});
		$(inputPass.getElement()).on('keypress', (e) => {
			if ((e.target as HTMLInputElement).value.trim() !== '' && e.key === 'Enter') {
				loginBtn.getElement().click();
			}
		});
	}

	public setInfoBar(): void
	{
		$( '#navbar-collapse-fixed-to-top-header-gsd-bitches-username-spanfield' ).parent().off();
		$( '#navbar-collapse-fixed-to-top-header-gsd-bitches-username-spanfield' ).parent().attr( 'disabled', 'disabled' );
		$( '#navbar-collapse-fixed-to-top-header-gsd-bitches-username-spanfield' ).text(
			this.Account ? this.Account.Username : app.getMessage( 'Aux.GUEST' )
		);

		if ( this.Person )
		{
			new Wollmilch.AJAX(
				{
					url: 'organization/show/' + this.Person,
					on:
					{
						success: ( text: string ) =>
						{
							const obj = Wollmilch.jsonize( text );

							if ( obj && obj.success && obj.data )
							{
								// Store the Employee data
								this.Employee = obj.data;
								$( '#navbar-collapse-fixed-to-top-header-gsd-bitches-username-spanfield' ).parent().removeAttr( 'disabled' );
							}
						}
					}
				}
			).send();
		}

		if ( this.Account )
		{
			new Wollmilch.AJAX(
				{
					url: 'organization/show/' + this.Account.Company,
					on:
					{
						success: ( text: string ): void =>
						{
							let obj;
							try
							{
								obj = JSON.parse( text );
							}
							catch ( e )
							{
								return;
							}

							if ( !obj.success )
							{
								return;
							}

							this.Company = obj.data;

							$( '#id_login_name' ).text( obj.data.Name + ' ' + obj.data.LegalForm );
						}
					}
				}
			).send();

			const listener = Backbone.Events;
			listener.listenTo(app.getObjectManager().getList(), 'sync', (data: SPA.Realtor.ObjectList) => {
				// Show Objectlist as default
				app.getGlobalTabControl().addTab('Objektverwaltung',
					new SPA.Realtor.List(), true
				);
			});
			app.getObjectManager().getList().fetch();
			// Todo Do we still need that?
			app.getContactManager().setCompany(this.Account.Company);
		}
	}

	public validateAuthtoken()
	{
		// Todo check steps for authentication - don't store data prior to assurance
		const AuthToken = localStorage.getItem('Auth-Token');
		if (!AuthToken)
		{
			localStorage.clear();

			const AccountLogin = new Account.Login();
			AccountLogin.createLoginBox();
			return;
		}

		new Wollmilch.AJAX({
			url: 'account/auth/' + AuthToken,
			method: 'GET',
			on: {
				always: (xhr: JQuery.jqXHR) =>
				{
					const obj = xhr.responseJSON;
					if (obj.success === false)
					{
						this.onAuthtokenReject();
					} else {
						this.onAuthtokenAccept(obj.data);
					}
				}
			}
		}, AJAXCallbase_e.APIV1).send();
	}

	public login(url: string, params: ui.Form.IFormParameter) : void
	{
		let label;
		let label2;
		new Wollmilch.AJAX(
			{
				url,
				method: 'POST',
				data: null,
				on:
				{
					beforeSend: ( o: Wollmilch.IAJAXOptions ) =>
					{
						this.RememberMe = params.remember_me;
						o.data = {
							username: params.username,
							password: params.password,
						};
					},
					success: (text: string) =>
					{

						let obj;

						try
						{
							obj = JSON.parse( text );
						}
						catch ( e )
						{
							// wtf for a simple parse error?
							label = app.getSpanMessage( 'Aux.ERROR.JSON_PARSE' );
							label2 = app.getSpanMessage( 'AuthenticationManager.ERROR.LOGIN_JSON_PARSE' );

							const bodylist: Array<JQuery<HTMLElement>|HTMLElement> = [];

							if ( label )
							{
								bodylist.push( label );
							}
							if ( label2 )
							{
								if ( label )
								{
									bodylist.push( ui.br() );
								}

								bodylist.push( label2 );
							}

							app.addToast(
								{
									body: bodylist,
									context: 'danger',
									timeout: Number(app.getConfigValue("ToastTimeout"))
								}
							);

							return;
						}

						if ( obj.success )
						{
							this.processLoginResult( obj.data );
						}
						else
						{
							app.addNotify(
								{
									title: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_PROCESS' ) ],
									body: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_FAILED' ) ],
									context: 'danger',
									timeout: Number(app.getConfigValue("ToastTimeout"))
								}
							);
						}
					},
					failed: ( status: number, xhr: JQuery.jqXHR ): void =>
					{
						app.addToast( { timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_AJAX_CALL_FAILED' ) ] } );
					}
				}
			}
		).send();
	}

	public logout() : void
	{
		if ( this.AuthToken == null )
		{
			return;
		}

		let label;
		let label2;
		new Wollmilch.AJAX(
			{
				url: 'account/logout',
				method: 'DELETE',
				on:
				{
					success: ( text: string ) =>
					{
						let obj;
						try
						{
							obj = JSON.parse( text );
						}
						catch ( e )
						{
							label = app.getSpanMessage( 'Aux.ERROR.JSON_PARSE' );
							label2 = app.getSpanMessage( 'AuthenticationManager.ERROR.LOGOUT_JSON_PARSE' );

							const bodylist: Array<JQuery<HTMLElement>|HTMLElement> = [];

							if ( label )
							{
								bodylist.push( label );
							}
							if ( label2 )
							{
								if ( label )
								{
									bodylist.push( ui.br() );
								}

								bodylist.push( label2 );
							}

							app.addNotify(
								{
									title: [ app.getSpanMessage( 'AuthenticationManager.LOGOUT_PROCESS' ) ],
									body: bodylist,
									context: 'danger',
									timeout: Number(app.getConfigValue("ToastTimeout"))
								}
							);

							return;
						}

						if ( obj.success )
						{
							$('#LOGOUT_BTN_ID').off();
							this.reset();
							Wollmilch.AuthToken = '';

							label = app.getSpanMessage( 'AuthenticationManager.LOGOUT_PROCESS' );
							label2 = app.getSpanMessage( 'AuthenticationManager.LOGOUT_SUCCESS' );

							if ( label2 )
							{
								const title = label ? label : document.createElement( 'span' );
								app.addNotify(
									{
										title: [ title ],
										body: [ label2 ],
										context: 'success',
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);
							}

							$('#LOGOUT_BTN_ID').hide();

							const wrapper = $('.login-wrapper');
							// Add loginscreen if its not available anymore
							if (wrapper.length === 0) {
								const LoginScreen = new Account.Login();
								LoginScreen.createLoginBox();
							}

							$('.login-wrapper').fadeIn('slow');
							$('.side-menu').fadeOut('slow');

							app.getContactManager().reset();
							app.getObjectManager().reset();
							app.getGlobalTabControl().removeAllTabs();

							// Todo Hide the annoying line this way for now
							app.getGlobalTabControl().Root().addClass('hidden');

							this.setInfoBar();
						}
						else
						{
							label = app.getSpanMessage( 'AuthenticationManager.LOGOUT_FAILED' );
							if ( label )
							{
								app.addNotify(
									{
										title: [ app.getSpanMessage( 'AuthenticationManager.LOGOUT_PROCESS' ) ],
										body: [ label ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);
							}
						}
					},
					failed: ( status: number, xhr: JQuery.jqXHR ) =>
					{
						app.addToast( { timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_AJAX_CALL_FAILED' ) ] } );
					}
				}
			}
		).send();
	}

	public showAllAccounts( vAccount: Wollmilch.AccountObject )
	{
		const allAccountsTable = new Table( { column_number: 7, bordered: true, striped: false, hover: true } );
		$( '#Account' ).append( allAccountsTable.getTable() );
		allAccountsTable.createHeaderRow(0, ['Name', 'gÃ¼ltig', 'Bearbeiten', 'active', 'visible', 'locked', 'deleted'] );

		const Password = new clChangePassword();

		new Wollmilch.AJAX(
		{
			url: "account/list/",
			method: 'GET',
			data: '',
			on:
			{
				success: ( text ) =>
				{
					let obj;
					try
					{
						obj = JSON.parse( text );
					}
					catch ( e )
					{
						alert( e.getMessage() );

						return;
					}
					if ( obj.success )
					{
						for ( const item of obj.data.data )
						{
							const editButton = new Button(
								{
									title: 'Account editieren',
									style: 'primary',
									block: false,
									size: 'xs',
									on:
									{
										click: () =>
										{
											new clEditAccount( item ).createModalEditAccount();
										}
									}
								}
							).getElement();

							const resetButton = new Button(
								{
									title: 'Passwort zurÃ¼cksetzen',
									style: 'danger',
									block: false,
									size: 'xs',
									on:
									{
										click: () =>
										{
											Password.resetPassword( item );
										}
									}
								}
							).getElement();

							let btn_active;
							let label_active;
							// Status-Button
							if ( item.Status.Active )
							{
								label_active = new InputLabel(
									{
										value: 'aktiv ',
										classes: ['status_okay']
									}
								).getElement();
								btn_active = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click:  () =>
											{
												new clStatus( item ).setInactiveStatus();
											}
										}
									}
								).getElement();
							}
							else
							{
								label_active = new InputLabel(
									{
										value: 'in-aktiv ',
										classes: ['status_becareful']
									}
								).getElement();
								btn_active = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setActiveStatus();
											}
										}
									}
								).getElement();
							}

							let btn_visible;
							let label_visible;
							if ( item.Status.Visible )
							{
								label_visible = new InputLabel(
									{
										value: 'sichtbar ',
										classes: [ 'status_okay' ]
									}
								).getElement();
								btn_visible = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setInvisibleStatus();
											}
										}
									}
								).getElement();
							}
							else
							{
								label_visible = new InputLabel(
									{
										value: 'unsichtbar ',
										classes: [ 'status_becareful' ]
									}
								).getElement();
								btn_visible = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{	click: () =>
											{
												new clStatus( item ).setVisibleStatus();
											}
										}
									}
								).getElement();
							}

							let btn_locked;
							let label_locked;
							if ( item.Status.Locked )
							{
								label_locked = new InputLabel(
									{
										value: 'gesperrt ',
										classes: [ 'status_becareful' ]
									}
								).getElement();
								btn_locked = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setUnlockStatus();
											}
										}
									}
								).getElement();
							}
							else
							{
								label_locked = new InputLabel(
									{
										value: 'frei ',
										classes: [ 'status_okay' ]
									}
								).getElement();
								btn_locked = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setLockedStatus();
											}
										}
									}
								).getElement();
							}

							let label_deleted;
							let btn_deleted;
							if ( item.Status.Deleted )
							{
								label_deleted = new InputLabel(
									{
										value: 'gelöscht ',
										classes: [ 'status_becareful' ]
									}
								).getElement();
								btn_deleted = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setUndeleteStatus();
											}
										}
									}
								).getElement();
							}
							else
							{
								label_deleted = new InputLabel(
									{
										value: 'nicht gelöscht ',
										classes: [ 'status_okay' ]
									}
								).getElement();
								btn_deleted = new Button(
									{
										title: 'change',
										block: false,
										size: 'xs',
										on:
										{
											click: () =>
											{
												new clStatus( item ).setDeleteStatus();
											}
										}
									}
								).getElement();
							}

							allAccountsTable.createDataRow(
								-1,
								[
									item.Username,
									item.DaysLeft,
									[ editButton, ' ', resetButton ],
									[ btn_active, ' ', label_active ],
									[ btn_visible, ' ', label_visible ],
									[ btn_locked, ' ', label_locked ],
									[ btn_deleted, ' ', label_deleted ]
								]
							);
						}
					}
				},
				failed: ( status, xhr ) =>
				{
					app.addToast(
						{
							timeout: Number(app.getConfigValue("ToastTimeout")),
							body: [ xhr.responseText ],
							context: 'danger'
						}
					);
				}
			}
		}
		).send();

	}

	private reset()
	{
		localStorage.clear();

		this.AuthToken = '';
		this.Account = null;
		this.Company = this.getEmptyCompany();
		this.Person = null;
		// Todo Employee Object
		this.Employee = null;
		this.RememberMe = false;

		this.Contacts = {raw: [], list: [], grouped: []};
	}

	private onAuthtokenAccept(data)
	{
		this.processLoginResult(data);
	}

	private onAuthtokenReject()
	{
		localStorage.clear();

		this.AuthToken = '';
		this.Account = null;
		this.Company = this.getEmptyCompany();
		this.Person = null;
		this.Employee = null;
		this.RememberMe = false;

		// Todo set Message in backend
		const msg = 'Sie haben GSD-Rapid an einem anderen PC oder Browser ebenfalls genutzt und sich dort abgemeldet. In diesem Browser war "Angemeldet bleiben" aktiv. <br><br>'
			+ 'Zu Ihrer Sicherheit wurden Sie an allen verwendeten Browsern ebenfalls abgemeldet. '
			+ 'Sollten Sie einen Verdacht auf einen unberechtigten Zugriff haben, wenden Sie sich umgehend an <a href="mailto:service@gsd-web.de">service@gsd-web.de</a><br><br>'
			+ 'Bitte melden Sie sich erneut an. ';
		const AccountLogin = new Account.Login();
		AccountLogin.setLoginMessage(msg);
		AccountLogin.createLoginBox();
	}

	private groupContacts(): any[]
	{
		const grouped: any[] = [];

		for (const contact of this.Contacts.raw)
		{
			for (const type of contact.types)
			{
				if (grouped[type.type] === undefined) {
					grouped[type.type] = [];
				}

				contact.data.aid = type.aid;
				contact.data.tid = type.tid;
				contact.data.object_number = type.object_number;
				grouped[type.type].push(contact.data);
			}
		}

		return grouped;
	}

	private processLoginResult( obj: {[key: string]: any})
	{
		// Added data from "remember me" checkbox
		Wollmilch.AuthToken = obj['Auth-Token'];
		this.AuthToken  = Wollmilch.AuthToken;
		this.Account    = obj.Account;
		this.Person     = obj.Person;

		localStorage.setItem('Auth-Token', this.AuthToken);

		app.getContactManager().getContacts().fetch({silent: true});
		// Todo Show the main navbar this way for now
		app.getGlobalTabControl().Root().removeClass('hidden');

		// app.addNotify(
		// 	{
		// 		title: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_PROCESS' ) ],
		// 		body: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_SUCCESS' ) ],
		// 		context: 'success',
		// 		timeout: Number(app.getConfigValue("ToastTimeout"))
		// 	}
		// );

		// $('#LOGIN_BTN_ID').hide();
		$('#LOGOUT_BTN_ID').show();
		$('.login-wrapper').fadeOut('slow');
		$('.side-menu').fadeIn('slow');
		$('#LOGOUT_BTN_ID').on( 'click', () => { app.getAuthenticationManager().logout(); return true; } );
		this.setInfoBar();
	}
}
